// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import * as AmplifyModules from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import awsconfig from './aws-exports';

import { Emarf } from '@/plugins/emarf';
import Router from 'vue-router';
import Login from './pages/Login.vue';
import Plugin from './pages/Plugin.vue';
import VueGtag from 'vue-gtag';
import i18n from '@/plugins/i18n';

Amplify.configure(awsconfig);

// const cookieStorageDomain = process.env.COOKIE_STORAGE_DOMAIN || 'localhost'
// console.log(cookieStorageDomain)

// See https://docs.amplify.aws/gen1/react/prev/tools/libraries/configure-categories/#scoped-configuration
// Amplify.configure({
//   Auth: {
//     cookieStorage: {
//       domain: cookieStorageDomain,
//       path: '/',
//       expires: 90,
//       secure: cookieStorageDomain !== 'localhost',
//     }
//   }
// })

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(i18n);
Vue.use(Emarf, {
	emarfEnv: process.env.EMARF_ENV,
	cloudwatch: {
		appkey: 'AKIAWOQM3DYAO5ZPA2BV', // CloudWatchLogに書き込むIAMユーザーのAPPキー
		appsec: 'FfFhKjUJpCtn3trTNGnZMnrMSB1fj3Z+QUVdWLfO', // CloudWatchLogに書き込むIAMユーザーのAPPシークレット
		region: 'ap-northeast-1', // CloudWatchLogのリージョン
		loggroup: '/app/userlogs/emarf4', // CloudWatchLogのロググループ
		logstream: 'emarf4-user-logs',  // CloudWatchLogのログストリーム
	},
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [ 'model-viewer' ];

Vue.use(Router);
const base = process.env.BASE_ENV || '/';
const router = new Router({
  base: base,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Plugin',
      component: Plugin
    },
    {
      path: '/preview',
      name: 'Preview',
      component: Plugin
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
});

Vue.use(VueGtag, {
  config: { id: "G-NZZ5SG1XQC", debug:true }
},router);

new Vue({
  router
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/plugin.js